<template>
  <div class="pay-result">
    <div class="top-icon" :class="iconClass">
      <icon-check class="top-icon-svg check" v-if="isSuccess" bg="transparent"/>
      <icon-cross color="#FFF" class="top-icon-svg" v-else/>
    </div>
    <p class="show-txt">{{showTxt}}</p>
    <div class="btn-area">
      <template v-if="isSuccess">
        <button class="btn btn-primary to-order-detail" @click="toOrderDetail">查看订单详情</button>
      </template>
      <template v-else>
        <button class="btn btn-primary btn-repay" @click="retryPay">重新支付</button>
        <button class="btn btn-ghost btn-cancel" @click="handleCancel">取消</button>
      </template>
    </div>
  </div>
</template>

<script>
  import IconCross from "../components/Icon/IconCross";
  import IconCheck from "../components/Icon/IconCheck";
  import {getPayType} from "@/utils/utils";
  import {mapActions,mapState} from 'vuex';
  export default {
    name: "PayResult",
    components: {IconCheck, IconCross},
    data() {
      return {
        routeName: '',
        routeParams: {},
      }
    },

    activated() {
      let {name: routeName, query:params } = this.$route
      this.routeName = routeName
      this.routeParams = params
    },
    methods: {
      ...mapActions(['printPay','rePay']),
      toOrderDetail() {
        let {type,id} = this.routeParams
          , routerParams
        //TODO:成功支付跳转的页面
        switch (type) {
          case 'single':
            routerParams = {name: 'orderDetail', params: {order_id: id}}; break;
          case 'merge':
            routerParams = {name: 'OrderList'}; break;
          default:
            this.WebTrack && this.WebTrack.trackCustom('PAID',{order_id:id})
            routerParams = {name: 'order'}; break;
        }
        this.$router.replace(routerParams)                                    
      },

      retryPay() {
        let {type,id} = this.routeParams
          , routerParams
        let paramType = getPayType(this.platformInfo.platform,type);
        switch (type) {
          case 'single':
          case 'merge':
            this.printPayWay(id,paramType); break;
          default:
            this.orderPay(id); break;
        }
      },
      orderPay(id){
        this.rePay({order_id:id}).then(res=>{
          res.data.pay.orderId = id;
          res.data.pay.description = "gopay";
          this.sdk.gopay('pages/miniApi/miniApi', res.data.pay);
        })
      },
      printPayWay(id,paramType){
        this.printPay({orderId:id, type:paramType}).then(res => {
          let payObj = {}
          if(this.platformInfo.platform === 'wechat'){
            payObj = res.data.signed_string
            payObj.orderId = id;
            payObj.description = "gopay";
            payObj.type = paramType;
          }
          if(this.platformInfo.platform === 'baidu'){
            payObj = {...res.data.orderInfo};
            payObj.orderId = id;
            payObj.description = "gopay";
            payObj.type = paramType;
          }
          this.sdk.gopay('pages/miniApi/miniApi', payObj);
        })
      },
      handleCancel() {
        this.$router.replace({name: 'order'})
      }
    },

    computed: {
      ...mapState(['platformInfo']),
      isSuccess() {
        return this.routeName === 'paySuccess'
      },

      showTxt() {
        return this.isSuccess ? '支付成功' : '支付失败'
      },

      iconClass() {
        return this.isSuccess ? 'succ' : 'fail'
      },
    }
  }
</script>

<style scoped lang="scss">
  * {box-sizing: border-box}

  .pay-result {
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    padding-top: 0.3rem;
  }

  .btn-primary,
  .btn-ghost {
    width: 3.11rem;
    height: 0.48rem;
    border-radius: 0.04rem;
    margin: 0.24rem auto;
    display: block;
    font-size: 0.18rem;
    font-weight: normal;
    background: #4455e4;
    color: #fff;
    border:none;
  }

  .top-icon {
    width: 0.94rem;
    height: 0.94rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 0.26rem;

    &.succ { background-color: #3b4ce0; }
    &.fail { background-color: #ea1712; }
    .top-icon-svg {
      width: 0.54rem;
      height: 0.54rem;

      &.check {
        width: 0.7rem;
        height: 0.7rem;
      }
    }
  }

  .btn-ghost {
    background-color: transparent;
    border: 1px solid #4455e4;
    color: #4455e4;
  }

  .show-txt {
    text-align: center;
    margin: 0;
    font-size: 0.2rem;
  }

</style>